import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";

export const HeaderTitle = styled.span`
  ${typographyMixin("subtitle", 2)}
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ModalSubtitle = styled.p`
  margin: ${spacing[1]} 0 0;
  max-width: 520px;
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const TableCard = styled.div`
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${({ theme }) => theme.borders.radius.lg};
  overflow: hidden;
  background-color: ${rawColors.structural.white};
`;

export const FooterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]};
  width: 100%;
`;

export const IconMenuButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: ${borderRadius.sm};
  background: transparent;
  color: ${rawColors.text.mediumEmphasis};
  cursor: pointer;

  &:hover {
    background-color: ${rawColors.stroke[100]};
    color: ${rawColors.text.highEmphasis};
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
  }
`;
